/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { view } from 'react-easy-state'
import Button from '../../components/generics/Button'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default view(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  interface TermsNCondState {
    confirm: boolean
  }

  const [COND, setCOND] = React.useState<TermsNCondState>({
    confirm: false
  })

  const checkCheckboxInput = (): boolean => {
    return !COND.confirm
  }

  const checkboxChangeValue = (e: any) => {
    console.log(e)
    if (COND.confirm) {
      setCOND({
        ...COND,
        confirm: false
      })
    } else {
      setCOND({
        ...COND,
        confirm: true
      })
    }
  }

  const confirmConditionClick = () => {
    navigate('/login-form', { replace: true })
  }

  return (
    <>
      <section className="term-n-cond-form pt-16">
        <div className="container">
          <div>
            <h6 className="" id="heading-term-n-cond">
              {t('viriyah.term-condition-page.title')}
            </h6>
          </div>
          <div
            id="condition-text-box"
            className="mt-custom-20"
            dangerouslySetInnerHTML={{ __html: t('viriyah.term-condition-page.description') }}
          />
        </div>
        <div className="bottom-section">
          <div className="container" id="checkbox-form">
            <label className="container-style">
              {t('viriyah.term-condition-page.check-box-label')}
              <input type="checkbox" onChange={checkboxChangeValue} />
              <span className="checkmark-style"></span>
            </label>
          </div>
          <Button
            id="button-style"
            isDisable={checkCheckboxInput()}
            customBgColor="#0033A2"
            optionalClass="w-100 pt-3 pb-3"
            textColor="white"
            onClick={confirmConditionClick}
          >
            {t('viriyah.term-condition-page.button-confirm')}
          </Button>
        </div>
      </section>
    </>
  )
})
